import React from "react";
import { Link } from "react-router-dom";
import Starfield from "@/components/Starfield";
import { ArrowLeft } from "lucide-react";

const CONTACT = "support@stellarsteps.online";

const Section = ({ title, children }) => (
  <section className="mb-7">
    <h2 className="font-heading text-lg md:text-xl font-bold text-cyan-300 mb-2">{title}</h2>
    <div className="text-slate-300 text-sm leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function Terms() {
  return (
    <div className="relative min-h-screen bg-[#0B0D1B] text-white overflow-hidden">
      <Starfield />
      <div className="relative z-10 max-w-3xl mx-auto p-5 sm:p-8 pb-28">
        <Link to="/" data-testid="terms-back-link" className="text-slate-400 hover:text-white flex items-center gap-1 text-sm mb-5">
          <ArrowLeft className="w-4 h-4" /> Back to Stellar Steps
        </Link>
        <h1 data-testid="terms-title" className="font-heading text-4xl sm:text-5xl font-bold mb-1">Terms of Use</h1>
        <p className="text-slate-400 mb-8 text-sm">Stellar Steps · Last updated June 2026</p>

        <Section title="1. Acceptance">
          <p>By using Stellar Steps you agree to these Terms. The service is provided for educational use by teachers and their pupils. If you are using it on behalf of a school, you confirm you are authorised to do so.</p>
        </Section>

        <Section title="2. Accounts & codes">
          <p>Teachers sign in with a name and an auto-generated 6-digit code. Pupils join with a class code and receive a personal return code. You are responsible for keeping these codes reasonably private. There are no passwords and pupils are not asked for any personal contact details.</p>
        </Section>

        <Section title="3. Acceptable use">
          <p>You agree not to misuse the service. In particular you will not enter offensive, harmful, or personal-identifying content, attempt to disrupt the service, or attempt to access classes you do not teach. Student-facing inputs are profanity-filtered, and teachers may remove any pupil from a session instantly.</p>
        </Section>

        <Section title="4. Child safety">
          <p>Stellar Steps contains no direct messaging between pupils, no public profiles, no searchable pupil directory, and no advertising. Pupils join by code only, without email registration.</p>
        </Section>

        <Section title="5. Content & data">
          <p>Teachers are responsible for the class and pupil content they create. Data is handled as described in our <Link to="/privacy" className="text-cyan-300 underline">Privacy Policy</Link>, including retention and deletion. You may request deletion at any time via the <Link to="/data-request" className="text-cyan-300 underline">Data Deletion Request form</Link>.</p>
        </Section>

        <Section title="6. Availability & liability">
          <p>The service is provided "as is" without warranties. To the extent permitted by law, we are not liable for any loss arising from use of the service. We may update or discontinue features to keep the service safe and reliable.</p>
        </Section>

        <Section title="7. Changes & contact">
          <p>We may update these Terms; continued use means you accept the changes. Questions: <a className="text-cyan-300 underline" href={`mailto:${CONTACT}`}>{CONTACT}</a>.</p>
        </Section>
      </div>
    </div>
  );
}
